import React, { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, AuthContextValue } from "../providers/AuthProvider";
import GuestLayout from "./GuestLayout";
import { Sidebar } from "./Sidebar";
import Header from "./Header";

type BaseLayoutProps = {
  children: ReactNode;
};

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { user } = useAuth() as AuthContextValue;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user && user.roleName && location.pathname === "/") {
      if (user.isFirstLogin && user.isFirstLogin === 1) {
        navigate("/changePassword?isFirstLogin=1");
      } else if (user.roleName === "ROLE_KFT_SUPER_ADMIN") {
        navigate("/admin");
      } else if (user.roleName === "ROLE_OFF_TAKER_ADMIN") {
        navigate("/off-taker");
      } else if (user.roleName === "ROLE_OFF_TAKER_OPERATION") {
        navigate("/off-taker");
      } else if (user.roleName === "BANK_ADMIN") {
        navigate("/bank");
      } else if (user.roleName === "INSURANCE_ADMIN") {
        navigate("/insurance");
      } else if (user.roleName === "ROLE_MPC_ADMIN") {
        navigate("/ad-dashboard");
      } else if (user.roleName === "ROLE_MPC_OPERATION") {
        navigate("/ad-dashboard");
      } else if (user.roleName === "ROLE_SUPER_ADMIN") {
        navigate("/sp-admin");
      } else if (user.roleName === "ROLE_KFT_SP_ADMIN") {
        navigate("/admin");
      } else if (
        user.roleName === "ROLE_MFI_ADMIN" ||
        user.roleName === "ROLE_MFI_OPERATION"
      ) {
        navigate("/mfi");
      }
    } else {
    }
  }, [location.pathname, navigate, user]);

  if (user && user.roleName) {
    return (
      <div className="flex h-screen">
        {/* Sidebar (Left) */}
        <aside className="w-60 bg-[#0b3b32] text-white p-3 rounded-2xl m-3 h-screen">
          <div className="text-xl font-bold mb-6 overflow-y-scroll h-full">
            <Sidebar />
          </div>
          {/* Sidebar items go here */}
        </aside>

        {/* Right section (Header + Content stacked vertically) */}
        <div className="flex flex-col flex-1">
          {/* Header (Top-right) */}

          <Header />

          {/* Main content (Bottom-right) */}
          <main className="flex-1 overflow-y-auto pt-2 pb-5 px-6">
            {children}
          </main>
        </div>
      </div>
    );
  } else {
    return <GuestLayout>{children}</GuestLayout>;
  }
};

export default BaseLayout;
